import { add, listen, qs, remove, contains } from '@fluorescent/dom';
import { get, set } from '@fluorescent/storage';
import { slideDown, slideUp, slideStop, isVisible } from 'slide-anim';

import priceRange from '@/lib/filters/price-range';
import { updateFilters } from '@/lib/filters/events';

const classes = {
  active: 'active',
  closed: 'closed',
};

const ls = {
  getClosed: () => get('closed_sidebar_groups') || [],
  setClosed: val => set('closed_sidebar_groups', JSON.stringify(val)),
};

const sel = {
  heading: '[data-heading]',
  tag: '[data-tag]',
  sort: '[data-sort]',
  priceRange: '[data-price-range]',
  getGroup: group => `[data-group="${group}"]`,
};

export default node => {
  if (!node) return Function();
  const sidebarForm = qs('[data-filter-form]', node);

  const events = [
    listen(node, 'click', handleClick),
    listen(node, 'change', handleChange),
  ];

  let range = null;
  const rangeContainer = qs(sel.priceRange, sidebarForm);

  if (rangeContainer) {
    range = priceRange(rangeContainer);
  }

  function handleChange(evt) {
    const { sort, filter, rangeInput } = evt.target.dataset;

    if (rangeInput || sort || filter) {
      updateFilters(sidebarForm);
    }
  }

  function handleClick(evt) {
    const { heading } = evt.target.dataset;

    if (heading) {
      evt.preventDefault();
      const { nextElementSibling: content } = evt.target;
      const contentContainsSwatches = contains(content, 'has-swatch');
      const blockType = contentContainsSwatches ? 'flex' : 'block';

      slideStop(content, {
        display: blockType,
      });

      const current = ls.getClosed();
      if (isVisible(content)) {
        add(evt.target, classes.closed);
        slideUp(content, {
          display: blockType,
        });
        ls.setClosed([...current, heading]);
      } else {
        remove(evt.target, classes.closed);
        slideDown(content, {
          display: blockType,
        });
        ls.setClosed(current.filter(item => item !== heading));
      }
    }
  }

  function unload() {
    range && range.unload();
    events.forEach(unsubscribe => unsubscribe());
  }

  return () => {
    unload();
  };
};
